var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.showHighlight)?_c('span',[_vm._v(" "+_vm._s(_vm.prefixValue)),_c('span',{staticClass:"matching"},[_vm._v(_vm._s(_vm.matchingValue))]),_vm._v(_vm._s(_vm.suffixValue)+" ")]):_c('span',[_vm._v(" "+_vm._s(_vm.content)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }